import { render } from "./App.vue?vue&type=template&id=d8e711a8"
const script = {}

import "./App.vue?vue&type=style&index=0&id=d8e711a8&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__